import * as R from 'ramda';
import { InternationalizationAction, InternationalizationState, InternationalizationContextActionTypes } from './types';
import { DEFAULT_LANGUAGE } from './defaultState';

const InternationalizationReducer = (
  state: InternationalizationState,
  action: InternationalizationAction,
): InternationalizationState => {
  let existingLanguage;

  switch (action.type) {
    case InternationalizationContextActionTypes.SetAvailableLanguages:
      return {
        ...state,
        availableLanguages: action.payload.availableLanguages,
        language: action.payload.language,
      };

    case InternationalizationContextActionTypes.SetTranslations:
      return {
        ...state,
        translations: action.payload,
      };

    case InternationalizationContextActionTypes.SetLanguage:
      existingLanguage = R.find(language => language.id === action.payload, state.availableLanguages);

      return {
        ...state,
        language: existingLanguage || DEFAULT_LANGUAGE,
        languageChanged: true,
      };

    default: {
      return state;
    }
  }
};

export { InternationalizationReducer };
